import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import Box from "@material-ui/core/Box";
import { DployTextField } from "@ploy-ui/form-fields";
import { DployTable } from "../DployTable";
import { FormattedMessage } from "react-intl";
import { BaseCamelCasedResource } from "@ploy-lib/rest-resources";
import { useDebounce } from "use-debounce";
import { legacyApiResourceUrl } from "@ploy-lib/core";
import { useStatefulResource } from "@rest-hooks/legacy";
class BisnodeCompanyResource extends BaseCamelCasedResource {
    pk() {
        return this.customerCompanyNumber;
    }
    static async fetch(input, init) {
        const response = await super.fetch(input, init);
        if (response.error)
            return [];
        return response;
    }
}
BisnodeCompanyResource.urlRoot = legacyApiResourceUrl("CustomerSearchJson/CompanyNameSearch");
const columns = [
    {
        title: (_jsx(FormattedMessage, { id: "ploy-ui.core.bisnodeSearch.orgNumber.text", description: "Organization number (bisnode modal)", defaultMessage: "Organization number" })),
        field: "customerCompanyNumber"
    },
    {
        title: (_jsx(FormattedMessage, { id: "ploy-ui.core.bisnodeSearch.orgName.text", description: "Organization name (bisnode modal)", defaultMessage: "Name" })),
        field: "customerName"
    },
    {
        title: (_jsx(FormattedMessage, { id: "ploy-ui.core.bisnodeSearch.orgAddress.text", description: "Organization address (bisnode modal)", defaultMessage: "Address" })),
        field: "address"
    },
    {
        title: (_jsx(FormattedMessage, { id: "ploy-ui.core.bisnodeSearch.orgZipcode.text", description: "Organization zip code (bisnode modal)", defaultMessage: "ZIP code" })),
        field: "zipCode"
    },
    {
        title: (_jsx(FormattedMessage, { id: "ploy-ui.core.bisnodeSearch.orgPostal.text", description: "Organization postal area (bisnode modal)", defaultMessage: "City" })),
        field: "postal"
    }
];
export function BisnodeSearch(props) {
    const { initialSearchValue = "", onSelect } = props;
    const [searchValue, setSearchValue] = useState(initialSearchValue);
    const [searchString] = useDebounce(searchValue, 350);
    const { data: companies = [], loading } = useStatefulResource(BisnodeCompanyResource.list(), searchString && searchString.length > 3
        ? {
            searchString
        }
        : null);
    return (_jsxs("div", { children: [_jsx(DployTextField, { autoFocus: true, variant: "outlined", label: _jsx(FormattedMessage, { id: "ploy-ui.core.bisnodeSearch.searchButton.text", description: "Text value of the search button (bisnode modal)", defaultMessage: "Search" }), value: searchValue, onChange: e => setSearchValue(e.target.value), margin: "normal" }), _jsx(Box, { position: "relative", children: _jsx(DployTable, { data: companies, isLoading: loading, columns: columns, options: {
                        search: false,
                        header: true,
                        toolbar: false,
                        pageSize: 5,
                        pageSizeOptions: [],
                        idSynonym: "customerCompanyNumber"
                    }, onRowClick: (e, rowData) => {
                        if (rowData && onSelect)
                            onSelect(rowData.customerCompanyNumber);
                    } }) })] }));
}
//# sourceMappingURL=BisnodeSearch.js.map